var _rect, _line, _line2, _rect2, _line3, _line4, _rect3, _line5, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorBureauDeChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.471,
    y: 16.449,
    width: 7.601,
    height: 10.775
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.129,
    y1: 16.449,
    x2: 9.129,
    y2: 9.762
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.129,
    y1: 33.911,
    x2: 9.129,
    y2: 27.224
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.074,
    y: 9.388,
    width: 7.601,
    height: 10.775
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21.731,
    y1: 9.388,
    x2: 21.731,
    y2: 2.701
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 21.731,
    y1: 26.85,
    x2: 21.731,
    y2: 20.163
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.928,
    y: 21.837,
    width: 7.601,
    height: 10.775
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 32.585,
    y1: 21.837,
    x2: 32.585,
    y2: 15.15
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 32.585,
    y1: 39.299,
    x2: 32.585,
    y2: 32.612
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorBureauDeChange);
export default __webpack_public_path__ + "static/media/indoor-bureau_de_change.a2b914893bbe10ed21a4f3f523e662ac.svg";
export { ForwardRef as ReactComponent };